/**
 * whatIsPopup what-is-popup
 */
angular.module('checkout').directive(
    'whatIsPopup',
    [
        function () {
            return {
                link: function ($scope) {
                    if (!$scope.propLabel) {
                        $scope.propLabel = "what's this?";
                    }
                },
                scope: {
                    propLabel: '=?label', // string
                    propMessage: '=message', // string
                },
                template: `
<span>
(<a href="javascript:void(0)" ng-click="showDialog=true">{{propLabel | translate}}</a>)
<div class="modal" ng-class="{show:showDialog}">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body" style="text-align: left">
                <p>{{propMessage | translate}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" ng-click="showDialog=false"
                        ng-bind="'Ok' | translate">
                </button>
            </div>
        </div>
    </div>
</div>
</span>
`,
            };
        },
    ]
);
